export const getDateForAge = (age: number) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - age);
  return date;
};
